module.exports = __webpack_public_path__ + "static/media/des_rev_2.7714ce7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/food/des_rev_2.jpg
// module id = 80
// module chunks = 0